import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import * as contentful from "contentful";
import dayjs from "dayjs";
import profileImg from "../img/profile.png";
import productImg1 from "../img/ミツクル.png";
import productImg2 from "../img/旅のしおり.png";

const LP = () => {
  const [blogItems, setBlogItems] = useState([]);
  const [sliderItems, setSliderItems] = useState([]);
  const [, setCurrentSlide] = useState(0);

  const client = useMemo(() => contentful.createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_DELIVERY_API
  }), []);

  useEffect(() => {
    client.getEntries({
      content_type: 'blogPost',
      limit: 5,
      order: '-sys.createdAt'
    }).then((response) => {
      setSliderItems(response.items);
      setBlogItems(response.items.slice(0, 3));
    });
  }, [client]);

  // 自動スライド
  useEffect(() => {
    if (sliderItems.length === 0) return;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderItems.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [sliderItems.length]);

  const formatDate = (date) => {
    const object = new Date(date);
    return dayjs(object).format('YYYY年MM月DD日');
  };

  const truncateString = (str, maxLength) => {
    if (!str) return "";
    if (str.length <= maxLength) return str;
    return str.substring(0, maxLength) + "...";
  };

  const skills = [
    { name: "PHP", level: 90 },
    { name: "Python", level: 80 },
    { name: "React", level: 75 },
    { name: "JavaScript", level: 85 },
    { name: "SQL", level: 80 },
    { name: "AWS", level: 70 }
  ];

  const products = [
    {
      id: 1,
      title: "ミツクル",
      description: "個人開発者向けプロダクト共有・管理プラットフォーム（GitHubで継続開発中）",
      image: productImg1
    },
    {
      id: 2,
      title: "旅のしおり",
      description: "旅行計画を作成・共有できるWebアプリケーション（GitHubで開発中）",
      image: productImg2
    }
  ];

  return (
    <div className="lp">
      {/* ABOUT セクション（左：アイコン / 右：経歴） */}
      <section className="lp-section">
        <h2 className="lp-section__title">ABOUT</h2>
        <div className="lp-about">
          <div className="lp-about__profile">
            <img className="lp-hero__image" src={profileImg} alt="masa" />
            <h1 className="lp-hero__name">masa</h1>
            <p className="lp-hero__tagline">Web Developer / Engineer</p>
          </div>
          <div className="lp-about__details">
            <ul className="lp-about__list">
              <li>2021年 大学卒業（外国語学部）、プログラミング学習開始</li>
              <li>2022年 SES企業</li>
              <li>2023年 HR自社開発企業</li>
              <li>現在 エンジニアとして活動中</li>
            </ul>
          </div>
        </div>
      </section>

      {/* SKILLS セクション */}
      <section className="lp-section">
        <h2 className="lp-section__title">SKILLS</h2>
        <div className="lp-skills">
          {skills.map((skill, index) => (
            <div key={index} className="lp-skill">
              <div className="lp-skill__header">
                <span className="lp-skill__name">{skill.name}</span>
                <span className="lp-skill__level">{skill.level}%</span>
              </div>
              <div className="lp-skill__bar">
                <div
                  className="lp-skill__progress"
                  style={{ width: `${skill.level}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* PRODUCTS セクション */}
      <section className="lp-section">
        <h2 className="lp-section__title">PRODUCTS</h2>
        <div className="lp-works">
          {products.map((product) =>
            product.title === "旅のしおり" ? (
              <a
                key={product.id}
                href="https://tabinoshiori.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="lp-work"
              >
                <img className="lp-work__image" src={product.image} alt={product.title} />
                <div className="lp-work__info">
                  <h3 className="lp-work__title">{product.title}</h3>
                  <p className="lp-work__description">{product.description}</p>
                </div>
              </a>
            ) : (
              <Link
                key={product.id}
                to={{ pathname: `/product/${product.id}` }}
                state={{ title: product.title, image: product.image }}
                className="lp-work"
              >
                <img className="lp-work__image" src={product.image} alt={product.title} />
                <div className="lp-work__info">
                  <h3 className="lp-work__title">{product.title}</h3>
                  <p className="lp-work__description">{product.description}</p>
                </div>
              </Link>
            )
          )}
        </div>
        <div className="lp-section__more">
          <Link to="/product" className="lp-button">すべてのプロダクトを見る</Link>
        </div>
      </section>

      {/* BLOG セクション */}
      <section className="lp-section">
        <h2 className="lp-section__title">BLOG</h2>
        <div className="lp-blogs">
          {blogItems.map((item, index) => (
            <Link
              key={index}
              to={{ pathname: `/blog/${item.sys.id}` }}
              state={{
                title: item.fields.title,
                body: item.fields.body,
                image: item.fields.image,
                createdAt: item.sys.createdAt
              }}
              className="lp-blog"
            >
              {item.fields.image && (
                <div className="lp-blog__thumb">
                  <img
                    src={item.fields.image.fields.file.url}
                    alt={item.fields.title}
                  />
                </div>
              )}
              <div className="lp-blog__body">
                <div className="lp-blog__date">{formatDate(item.sys.createdAt)}</div>
                <h3 className="lp-blog__title">{item.fields.title}</h3>
                <p className="lp-blog__description">
                  {truncateString(item.fields.description, 60)}
                </p>
              </div>
            </Link>
          ))}
        </div>
        <div className="lp-section__more">
          <Link to="/blog" className="lp-button">すべての記事を見る</Link>
        </div>
      </section>

      {/* SNS セクション */}
      <section className="lp-section lp-sns">
        <h2 className="lp-section__title">SNS</h2>
        <div className="lp-sns__links">
          <a href="https://twitter.com/mg10313273" target="_blank" rel="noopener noreferrer" className="lp-sns__link">
            <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 0 448 512">
              <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"/>
            </svg>
            <span>Twitter / X</span>
          </a>
        </div>
      </section>
    </div>
  );
};

export default LP;
